import React, { Component, Fragment } from 'react';
import map from 'lodash.map';
import filter from 'lodash.filter';
import isEmpty from 'lodash.isempty';
import isEqual from 'lodash.isequal';
import moment from 'moment';
import Truncate from 'react-truncate';
import SVG from 'react-inlinesvg';
import { ProjectStatus, ProjectMode, ProjectType, ConsultationFormType, ImageMimeType } from '../../../utils/enums';
import { dayFormat } from '../../../utils/date';
import { ProjectInfo } from './ProjectInfo';
import { replaceEndOfLine } from '../../../utils/text-extensions';
import { transformSVG } from '../../../utils/svg-extensions';

export default class ProjectListItem extends Component {
	constructor(props) {
		super(props);

		this.state = {
			canVote: this.canVote(),
			isVoted: this.isVoted(),
			hasOnlyPostAddressForm:
				props.consultationForms && props.consultationForms.length > 0
					? props.consultationForms.every((item) => item.type === ConsultationFormType.PostAddress)
					: false,
			...this.calculateUserVote()
		};

		this.replaceEndOfLine = replaceEndOfLine.bind(this);
	}

	componentDidUpdate(prevProps) {
		if (!isEqual(prevProps.consultationForms, this.props.consultationForms)) {
			this.setState({
				canVote: this.canVote(),
				isVoted: this.isVoted(),
				hasOnlyPostAddressForm:
					this.props.consultationForms && this.props.consultationForms.length > 0
						? this.props.consultationForms.every((item) => item.type === ConsultationFormType.PostAddress)
						: false,
				...this.calculateUserVote()
			});
		}
	}

	canVote() {
		const isCanVote = !isEmpty(this.props.consultationForms)
			? this.props.consultationForms.some(
					(item) => !item.voted && !item.outOfRangeVoteDates && !item.outOfRangeDistricts
				)
			: false;

		return isCanVote;
	}
	isVoted() {
		const consultationFormToVoteMode = filter(
			this.props.consultationForms,
			(form) => form.type === ConsultationFormType.Probe || form.type === ConsultationFormType.Survey
		);

		if (!isEmpty(consultationFormToVoteMode) && this.props.type === ProjectType.Consultation) {
			return consultationFormToVoteMode.every((item) => item.voted);
		}
		return !isEmpty(consultationFormToVoteMode) ? consultationFormToVoteMode.some((item) => item.voted) : false;
	}
	calculateUserVote() {
		if (
			isEmpty(
				filter(
					this.props.consultationForms,
					(form) => form.type === ConsultationFormType.Probe || form.type === ConsultationFormType.Survey
				)
			)
		) {
			return {
				availableVoteForms: 0,
				voteForms: 0
			};
		}

		return {
			availableVoteForms:
				filter(this.props.consultationForms, (form) => {
					const actualTime = moment();
					const voteFrom = moment(form.voteFrom);
					return (
						(form.type === ConsultationFormType.Probe || form.type === ConsultationFormType.Survey) &&
						voteFrom.isSameOrBefore(actualTime)
					);
				}).length || 0,
			voteForms:
				filter(this.props.consultationForms, (form) => {
					const actualTime = moment();
					const voteFrom = moment(form.voteFrom);
					return (
						(form.type === ConsultationFormType.Probe || form.type === ConsultationFormType.Survey) &&
						voteFrom.isSameOrBefore(actualTime) &&
						form.voted
					);
				}).length || 0
		};
	}

	getRedirectText(type) {
		switch (type) {
			case ProjectType.Consultation:
				return {
					vote: 'Przejdź do konsultacji',
					preview: 'Przejdź do konsultacji'
				};
			case ProjectType.Survey:
				return {
					vote: 'Przejdź do ankiety',
					preview: 'Przejdź do ankiety'
				};
			default:
				return {
					vote: 'Przejdź do głosowania',
					preview: 'Przejdź do szczegółów'
				};
		}
	}

	render() {
		const { isVoted, canVote, availableVoteForms, voteForms, hasOnlyPostAddressForm } = this.state;
		const {
			id,
			title,
			dateFrom,
			dateTo,
			status,
			statusName,
			moderatorName,
			votedForAllForms,
			commentAdded,
			shortDescription,
			mode,
			modeName,
			thematicAreaName,
			onlyForLegalAge,
			description,
			isLegalAgeUser,
			isOnlyOneOffice,
			officeName,
			type,
			isAuth,
			loggedOfficeId,
			officeId,
			thumbImageContentType,
			thumbImage,
			isParticipate,
			loggedUserIsCitizen
		} = this.props;
		const socialGroupNames = map(this.props.socialGroups, (socialGroup) => socialGroup.socialGroupName);
		const socialGroupsText = socialGroupNames.length > 0 ? socialGroupNames.join(', ') : '';
		const dateTimeNow = moment();
		const dateToMoment = moment(dateTo);
		const dateFromMoment = moment(dateFrom);
		const redirectText = this.getRedirectText(type);
		const substringDescription = description ? description.substring(0, 270) : '';
		const showVoteButton =
			!votedForAllForms &&
			canVote &&
			status === ProjectStatus.Active &&
			dateFromMoment.isSameOrBefore(dateTimeNow) &&
			dateToMoment.isSameOrAfter(dateTimeNow) &&
			(onlyForLegalAge ? isLegalAgeUser : true) &&
			(mode === ProjectMode.Citizen ? isAuth && loggedUserIsCitizen && officeId === loggedOfficeId : true) &&
			(mode === ProjectMode.Close ? isAuth : true);
		const showPreviewButton =
			(votedForAllForms ||
				!canVote ||
				(onlyForLegalAge ? !isLegalAgeUser : false) ||
				(mode === ProjectMode.Citizen ? !isAuth || !loggedUserIsCitizen || officeId !== loggedOfficeId : false) ||
				((mode === ProjectMode.Close ? !isAuth : false) &&
					(dateFromMoment.isSameOrBefore(dateTimeNow) && dateToMoment.isSameOrAfter(dateTimeNow)))) &&
			status === ProjectStatus.Active;
		const showResultButton =
			status >= ProjectStatus.Close;//&& (dateFromMoment.isAfter(dateTimeNow) || dateToMoment.isBefore(dateTimeNow));

		return (
			<div className="consultation-item">
				<div className="consultation-item__body">
					{type === ProjectType.Consultation && (
						<div className="consultation-description__thumbnail">
							{thumbImageContentType !== ImageMimeType.SVG && (
								<div className="svg-container">
									<img
										className="thumbnail__content"
										src={`data:image/jpeg;base64, ${thumbImage}`}
										alt="Ikona kategorii"
									/>
								</div>
							)}
							{thumbImageContentType === ImageMimeType.SVG && (
								<div className="svg-container">
									<SVG src={transformSVG(thumbImage, `svg-${id}`, 'Ikona kategorii')} />
								</div>
							)}
						</div>
					)}
					<div className="consultation-item__flex-row consultation-item__flex-row--direction-column">
						<div className="consultation-item__header">{title}</div>
						<div className="consultation-item__flex-row consultation-item__flex-row--max-height">
							<div className="consultation-description__text margin-right-20">
								<Truncate
									lines={5}
									ellipsis={
										<span>
											...<a
												onClick={() =>
													!showVoteButton
														? this.props.onProjectPreview(this.props.id)
														: this.props.onProjectVote(this.props.id)}
												className="link"
												title={!showVoteButton ? redirectText.preview : redirectText.vote}
											>
												&nbsp;więcej
											</a>
										</span>
									}
								>
									<div
										style={{ display: 'inline' }}
										dangerouslySetInnerHTML={{
											__html: `${this.replaceEndOfLine(substringDescription)}`
										}}
									/>
								</Truncate>
							</div>
							<ProjectInfo
								{...{
									type,
									thematicAreaName,
									dateFrom,
									dateTo,
									modeName,
									onlyForLegalAge,
									isAuth,
									isVoted,
									availableVoteForms,
									voteForms,
									isParticipate,
									isOnlyOneOffice,
									officeName,
									hasOnlyPostAddressForm
								}}
							/>
						</div>
					</div>
				</div>
				<div className="consultation-item__footer">
					{showVoteButton && (
						<div className="consultations__projects">
							<a
								disabled={this.props.id === 0}
								className="button button--primary-dark button--width-auto"
								title={redirectText.vote}
								onClick={() => this.props.onProjectVote(this.props.id)}
							>
								{redirectText.vote}
							</a>
						</div>
					)}
					{showPreviewButton && (
						<div className="consultations__projects">
							<a
								disabled={this.props.id === 0}
								className="button button--primary-dark button--width-auto"
								title={redirectText.preview}
								onClick={() => this.props.onProjectPreview(this.props.id)}
							>
								{redirectText.preview}
							</a>
						</div>
					)}
					{showResultButton && (
						<div className="consultations__projects">
							<a
								disabled={this.props.id === 0}
								className="button button--primary-dark button--width-auto"
								title="Przejdź do wyników"
								onClick={() => this.props.onProjectPreview(this.props.id)}
							>
								Przejdź do wyników
							</a>
						</div>
					)}
				</div>
			</div>
		);
	}
}
